import {intlTelInputBuilder} from "../intlTelInput/intlTelInput";
import {loadAlertifyAsync} from "../alertify/alertify";

let alertify = null;

export const teLlamamos = ($form) => {

    const success_message = 'Nos podremos en contacto con usted lo antes posible';

    loadAlertifyAsync()
        .then(alertifyModule => {
            alertify = alertifyModule;
        })
        .catch(err => {
            alertify = null;
        });

    $form.on('submit', function(e){
        e.preventDefault();
        const $form = $(this);

        //Validar que el intlTelInput es válido.
        const intlTelInputInstances = window.intlTelInputGlobals.instances;
        for(let key in intlTelInputInstances) {
            if (intlTelInputInstances.hasOwnProperty(key) &&
                intlTelInputInstances[key].telInput.id === 'Contact_phone_tel') {
                if (!intlTelInputInstances[key].isValidNumber()) {
                    console.error('Invalid phone');
                    return false;
                }
            }
        }

        $.ajax({
            url: $form.attr('action'),
            type: $form.attr('method'),
            data: $form.serialize(),
            success: function (data) {
                if (data.status === 'OK') {
                    if (alertify) {
                        alertify.alert(success_message, () => {
                            $form.remove();
                        });
                    } else {
                        alert(success_message);
                        $form.remove();
                    }
                }else {
                    const $newForm = $(data.html).find('form[name="Contact"]' );
                    intlTelInputBuilder($newForm.find('input[id$="_tel"]'));
                    $form.html($newForm);
                    teLlamamos($newForm);
                }
            }
        });

        return false;
    });
}
